/*
export const someGetter = (state) => {}
 */
import { formatDate } from 'src/utils'
export default {
  orderList,
  orderTypeOptions,
  userOverrideList,
  courseOverrideList,
  affiliateOverrideList,
  userOverrideOptions,
  courseOverrideOptions,
  affiliateOverrideOptions,
  searchOrderTypeOptions
}

function orderList (state) {
  return state.list.map(order => {
    if (order.ORDER_TYPE) {
      _.each(order.ORDER_TYPE, (val, key) => {
        if (!order[key]) order[key] = val
      })
    }

    if (order.USER) {
      _.each(order.USER, (val, key) => {
        if (!order[key]) order[key] = val
      })
    }

    if (order.ORDER_STATUS) {
      _.each(order.ORDER_STATUS, (val, key) => {
        if (!order[key]) order[key] = val
      })
    }

    if (order.CLASS) {
      _.each(order.CLASS, (val, key) => {
        if (!order[key]) order[key] = val
      })
    }

    return order
  })
}

function orderTypeOptions (state) {
  return _.sortBy(_.map(state.orderTypes, orderType => {
    return { label: _.startCase(_.toLower(orderType.ORDER_TYPE_NAME)), value: Number.parseInt(orderType.ORDER_TYPE_ID), price: orderType.PRICE, item: orderType }
  }), (o) => {
    return o.label // sorting by label
  })
}

function searchOrderTypeOptions (state) {
  return _.sortBy(_.map(state.searchOrderTypes, orderType => {
    return { label: _.startCase(_.toLower(orderType.ORDER_TYPE_NAME)), value: Number.parseInt(orderType.ORDER_TYPE_ID), price: orderType.PRICE, item: orderType }
  }), (o) => {
    return o.label // sorting by label
  })
}

function userOverrideList (state) {
  return state.orderTypeOverrides.map((userOverride, index) => {
    // if (userOverride.USER) {
      // _.each(userOverride.USER, (val, key) => {
      //   if (!userOverride[key]) userOverride[key] = val
      // })
    // }
    userOverride.overrideIndex = index
    return userOverride
  }).filter(orderTypeOverride => orderTypeOverride.LK_ENTITY_ID === 1)
}

function courseOverrideList (state) {
  return state.orderTypeOverrides.map((userOverride, index) => {
    userOverride.overrideIndex = index
    return userOverride
  }).filter(orderTypeOverride => orderTypeOverride.LK_ENTITY_ID === 2)
}

function affiliateOverrideList (state, getters, rootState, rootGetters) {
  return state.orderTypeOverrides.map((affiliateOverride, index) => {
    affiliateOverride.overrideIndex = index
    return affiliateOverride
  }).filter(orderTypeOverride => orderTypeOverride.LK_ENTITY_ID === 9)
}

function userOverrideOptions (state, getters, rootState, rootGetters) {
  const userAutoCompleteOptions = rootGetters["users/autoCompleteOptions"]
  const userOverrides = getters.userOverrideList
  return _.differenceWith(userAutoCompleteOptions, userOverrides, (userOption, userOverride) => {
    return userOption.item.USER_ID === userOverride.USER.USER_ID
  })
}

function courseOverrideOptions (state, getters, rootState, rootGetters) {
  const courseAutoCompleteOptions = rootGetters["courses/autoCompleteOptions"]
  const courseOverrides = getters.courseOverrideList
  return _.differenceWith(courseAutoCompleteOptions, courseOverrides, (courseOption, courseOverride) => {
    return courseOption.item.COURSE_ID === courseOverride.COURSE.COURSE_ID
  })
}

function affiliateOverrideOptions (state, getters, rootState, rootGetters) {
  const affiliateAutoCompleteOptions = rootGetters["users/affiliateAutoCompleteOptions"]
  const affiliateOverrides = getters.affiliateOverrideList
  return _.differenceWith(affiliateAutoCompleteOptions, affiliateOverrides, (affiliateOption, affiliateOverride) => {
    return affiliateOption.item.USER_ID === affiliateOverride.USER.USER_ID
  })
}
